"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _element = require("../utils/dom/element");

var _formContext = require("./formContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(htmlType) {
  var _class, _temp;

  return (0, _formContext.formConsumer)(['disabled'], (_temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose(FormButton, _PureComponent);

    function FormButton(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = FormButton.prototype;

    _proto.bindElement = function bindElement(el) {
      this.button = el;
    };

    _proto.handleClick = function handleClick() {
      if (htmlType === 'button') {
        var form = (0, _element.getParent)(this.button, 'form');
        (0, _element.dispatchEvent)(form, 'submit');
      }

      if (this.props.onClick) this.props.onClick();
    };

    _proto.render = function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          other = _objectWithoutPropertiesLoose(_this$props, ["children", "onClick"]);

      var type = this.props.type || (htmlType === 'reset' ? 'default' : 'primary');
      return _react.default.createElement(_Button.default, _extends({}, other, {
        type: type,
        htmlType: htmlType,
        onRef: this.bindElement,
        onClick: this.handleClick
      }), children);
    };

    return FormButton;
  }(_react.PureComponent), _defineProperty(_class, "propTypes", {
    children: _propTypes.default.any,
    disabled: _propTypes.default.bool,
    loading: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    type: _propTypes.default.string
  }), _temp));
};

exports.default = _default;